module.exports = __webpack_public_path__ + "files/1c1474c483dc63fd98a595784e308658.png";